import styled from 'styled-components';
import { palette } from 'styled-tools';

import { ChevronDown as chevronDown } from '@calm-web/icons';

import { units } from '../../utils/spacing';
import Button from '../Button';
import Checkbox from '../Checkbox';
import { PaletteColor } from '../ThemeProvider';

export const StyledFieldset = styled.fieldset`
	border: none;
	display: flex;
	flex-direction: column;
`;

export const StyledText = styled.div`
	margin-left: ${units(2)};
	padding: 0px 6px;
`;

export const StyledButton = styled(Button)`
	height: ${units(6)};
`;
export const DownArrow = styled(chevronDown)<{ $downArrowColor?: PaletteColor }>`
	display: flex;
	height: ${units(1.5)};
	left: ${units(1.5)};
	align-items: center;
	pointer-events: none;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	padding: 2px;
	width: ${units(2)};
	z-index: 1;

	& path {
		fill: ${p => (p.$downArrowColor ? palette(p.$downArrowColor) : palette('inputLabel'))};
	}
`;

export const StyledCheckbox = styled(Checkbox)`
	padding: ${units(0.75)} ${units(1.5)};
`;
